<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-tree-select
                v-model="queryParam.catId"
                placeholder="请选择供应商类别"
                treeDefaultExpandAll
                :treeData="categoryData"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="输入供应商编号/名称" v-model="queryParam.kw"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value="" v-model="queryParam.status">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="active">启用</a-select-option>
                <a-select-option value="deleted">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetTableSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="default" icon="reload" @click="reloadTable">刷新</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="status" slot-scope="text, record">
        <a-switch checkedChildren="启用" unCheckedChildren="禁用" defaultChecked v-if="record.status == 'active'" @change="statusChange($event, record)"/>
        <a-switch checkedChildren="启用" unCheckedChildren="禁用" v-else  @change="statusChange($event, record)"/>
      </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm placement="topLeft" title="确定要删除此供应商吗?删除后无法恢复！" @confirm="deleteConfirm(record.id)" okText="确定" cancelText="取消">
                <a href="#">删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <SupplierForm
      :isEditForm="isEditForm"
      :title="title"
      :visible="visible"
      :formdata="selectrow"
      @formcancel="formcancel"
      @formsuccess="formsuccess"></SupplierForm>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import SupplierForm from '@/components/Supplier/Form'
import { getSupplierList, editSupplier, deleteSupplier } from '@/api/supplier'
import { getCategorySupplier } from '@/api/category'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'SettingsSupplierList',
  components: {
    STable,
    SupplierForm
  },
  data () {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      isEditForm: false,
      title: '新增供应商',
      selectrow: {},

      // 查询参数
      queryParam: {
        kw: '',
        catId: '0',
        status: ''
      },
      categoryData: null,
      // 表头
      columns: [
        {
          title: '供应商编号',
          dataIndex: 'locationNo'
        },
        {
          title: '供应商名称',
          dataIndex: 'name'
        },
        {
          title: '供应商类别',
          dataIndex: 'category.name'
        },
        {
          title: '联系人',
          dataIndex: 'contactName'
        },
        {
          title: '手机',
          dataIndex: 'contactPhone'
        },
        {
          title: '联系地址',
          dataIndex: 'contactAddress'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getSupplierList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    this.loadCategory()
  },
  methods: {
    formcancel () {
      this.visible = false
    },
    formsuccess (values) {
      this.visible = false
      this.reloadTable()
    },
    handleEdit (record) {
      this.selectrow = Object.assign({}, record)
      this.title = '编辑供应商资料'
      this.isEditForm = true
      this.visible = true
    },
    handleAdd () {
      this.selectrow = {
        locationNo: '',
        taxPayerNo: '',
        name: '',
        catId: '0',
        bank: '',
        cardNo: '',
        note: '',
        contactName: '',
        contactPhone: '',
        contactAddress: ''
      }
      this.title = '新增供应商'
      this.isEditForm = false
      this.visible = true
    },

    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    resetTableSearch () {
      this.queryParam = {
        kw: '',
        catId: '0',
        status: ''
      }
      this.reloadTable()
    },
    statusChange (event, record) {
      const data = record
      data.status = event === true ? 'active' : 'deleted'
      editSupplier(data).then(res => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('修改成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    loadCategory () {
      getCategorySupplier({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    deleteConfirm (id) {
      deleteSupplier({ id: id }).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
          this.reloadTable()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  watch: {
  }
}
</script>
